"use client";

import { useTranslations } from "@i18n/next";
import type { HallowABFlag } from "@packages/ab";
import { useFlag } from "@packages/ab";
import { Button } from "@packages/ui";
import { useMemo } from "react";

import { LINKS } from "../../../constants";
import { useABLoadingWithTimeout } from "../../../hooks/useABLoadingWithTimeout";
import type { CTAProps } from "./CTA";
import { CTA } from "./CTA";

type CtaWithABTestProps = {
  baseProps: CTAProps;
  controlProps?: Partial<CTAProps>;
  treatmentProps: Partial<CTAProps>;
  flag: HallowABFlag;
  treatmentValue?: string;
  controlValue?: string;
};

const Internal = ({
  baseProps,
  controlProps = baseProps,
  treatmentProps,
  flag,
  treatmentValue = "treatment",
  controlValue = "control",
}: CtaWithABTestProps) => {
  const { isTargeted: inTreatment } = useFlag({
    isTargetedValue: treatmentValue,
    key: flag,
  });
  const { isTargeted: inControl } = useFlag({
    isTargetedValue: controlValue,
    key: flag,
  });
  const props = useMemo(
    () => ({
      ...baseProps,
      ...(inControl ? controlProps : {}),
      ...(inTreatment ? treatmentProps : {}),
    }),
    [baseProps, treatmentProps, inTreatment, inControl],
  );
  return <CTA {...props} />;
};

export const CtaWithABTest = (props: CtaWithABTestProps) => {
  const { isLoading } = useABLoadingWithTimeout();
  const t = useTranslations();
  if (isLoading)
    return (
      <Button disabled size={props.baseProps.size}>
        {t(LINKS.tryHallowForFree.message)}
      </Button>
    );
  return <Internal {...props} />;
};
